import React, { useEffect, useState, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import Modal from "../Modal";
import KPIWizard from "../KPIWizard";
import ObjectiveWizard from "../ObjectiveWizard";
import PerspectiveForm from "../Perspectives/EditForm";

import { ReactComponent as PlusIcon } from "../../assets/images/plus-symbol.svg";
import useIsAr from "../../Hooks/useIsAr";
import "./style.scss";

function DropDown() {
  const [isOpened, setIsOpened] = useState(false);
  const [showHidePerspective, setShowHidePerspective] = useState(false);
  const [showHideStrategicObjective, setShowHideStrategicObjective] =
    useState(false);
  const [showHideKPI, setShowHideKPI] = useState(false);
  const wrapperRef = useRef();

  const [isAr] = useIsAr();

  const items = [
    {
      name: "common.perspective",
      onClick: () => {
        setShowHidePerspective(true);
      },
    },
    {
      name: "common.strategic-objective",
      onClick: () => {
        setShowHideStrategicObjective(true);
      },
    },
    {
      name: "common.kpi",
      onClick: () => {
        setShowHideKPI(true);
      },
    },
  ];

  const handleClickOutside = (event) => {
    if (wrapperRef?.current && !wrapperRef?.current?.contains(event.target)) {
      setIsOpened(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`custom-dropdown ${isAr && "dd-rtl"}`} ref={wrapperRef}>
      <ul id="menu">
        <li>
          <input
            id="check01"
            type="checkbox"
            name="menu"
            checked={isOpened}
            onChange={() => setIsOpened(!isOpened)}
          />
          <label className="men-label" htmlFor="check01">
            <PlusIcon fill="#fff" />
          </label>

          <ul className="submenu">
            {items.map((item) => (
              <li key={item.name} onClick={item?.onClick}>
                <Space align="center" className="item">
                  <span>
                    <FormattedMessage id={item?.name} />
                  </span>
                </Space>
              </li>
            ))}
          </ul>
        </li>

        {showHidePerspective && (
          <Modal isOpen={showHidePerspective}>
            <PerspectiveForm
              data={null}
              closeModal={() => setShowHidePerspective(false)}
            />
          </Modal>
        )}

        {showHideStrategicObjective && (
          <Modal isOpen={showHideStrategicObjective}>
            <ObjectiveWizard
              modeSaveOrUpdate
              closeModal={() => setShowHideStrategicObjective(false)}
            />
          </Modal>
        )}

        {showHideKPI && (
          <Modal isOpen={showHideKPI}>
            <KPIWizard
              modeSaveOrUpdate
              closeModal={() => setShowHideKPI(false)}
            />
          </Modal>
        )}
      </ul>
    </div>
  );
}

export default DropDown;
